import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { URLS } from '@wix/da-url';

import s from './TwoFactorRequiredModal.scss';

export interface Props {
  isOpen: boolean;
  requestClose: () => void;
}

const TwoFactorRequiredModal: FC<Props> = ({ isOpen, requestClose }) => {
  const { t } = useTranslation();

  const handleGoToSettings = () => {
    window.location.href = URLS.SETTINGS_AUTHENTICATION;
  };

  return (
    <MessageModal
      className={s['wrapper']}
      contentClassName={s['content']}
      variant="horizontal"
      title={t('studio.earnings.twoFactorRequired.title')}
      message={
        <div className={s['description']}>
          {t('studio.earnings.twoFactorRequired.description')}{' '}
          <a href={URLS.SETTINGS_AUTHENTICATION} className={s['underline']}>
            {t('studio.earnings.twoFactorRequired.twoFactorLink')}
          </a>{' '}
          {t('studio.earnings.twoFactorRequired.description.suffix')}
        </div>
      }
      footerButtons={[
        <TextButton onClick={requestClose} size="large" variant="main" key="cancel">
          {t('common.cancel')}
        </TextButton>,
        <BrandedButton
          onClick={handleGoToSettings}
          size="large"
          variant="brand-green"
          key="goto-settings"
        >
          {t('studio.earnings.twoFactorRequired.goToSettings')}
        </BrandedButton>,
      ]}
      onRequestClose={requestClose}
      shouldCloseOnOverlayClick
      isOpen={isOpen}
    />
  );
};

TwoFactorRequiredModal.displayName = 'TwoFactorRequiredModal';

export default TwoFactorRequiredModal;
